<app-data-table mainTitle="Usuários"
                singleTitle="Usuário"
                routerPath="/usuario"
                entityPath="/usuario"
                [entity]="usuario"
                [columns]="this['columns']"
                [controls]="this['controls']"
                extras="projetoDblRelacs/id,projetoDblRelacs/projetoDbl/id,projetoDblRelacs/empresa/id,projetoDblRelacs/usuario/id">
</app-data-table>
